<template>
  <v-container fluid>
    <v-row v-if="settings">
      <v-col cols="12" md="3">
        <h3>Lead Times</h3>
      </v-col>
      <v-col cols="4" md="3">
        <h4>UK</h4>
        <v-text-field
          v-for="(a, index) in sortedObject(settings.leadTimes.uk)"
          v-model.number="settings.leadTimes.uk[a[0]]"
          :label="a[0]"
          :key="index"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="4" md="3">
        <h4>EU</h4>
        <v-text-field v-model.number="settings.leadTimes.eu.leadTime" label="leadTime" required></v-text-field>
      </v-col>
      <v-col cols="4" md="3">
        <h4>US</h4>
        <v-text-field
          v-for="(a, index) in sortedObject(settings.leadTimes.us)"
          v-model.number="settings.leadTimes.us[a[0]]"
          :label="a[0]"
          :key="index"
          required
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="9" offset-md="3" class="pt-0">
        <v-btn block color="accent" variant="flat" @click="updateLeadTimes">
          <span v-if="!leadTimesSubmitting">Save</span>
          <v-progress-circular v-else :size="20" :width="2" indeterminate></v-progress-circular>
        </v-btn>
      </v-col>
      <v-col cols="12" md="3">
        <h3>Mu Settings</h3>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          :disabled="!['sho@plykea.com', 'kath@plykea.com', 'adam@plykea.com'].includes($store.state.user.email)"
          v-model.number="muSettings.muCutCapacity"
          label="Cut Capacity"
          suffix="per day"
        ></v-text-field>
        <v-text-field
          :disabled="!['sho@plykea.com', 'kath@plykea.com', 'adam@plykea.com'].includes($store.state.user.email)"
          v-model.number="muSettings.muWorkshopCapacity"
          label="Workshop Capacity"
          suffix="per person per day"
        ></v-text-field>
        <!-- <v-text-field -->
      </v-col>
      <v-col cols="12" md="9" offset-md="3" class="pt-0">
        <v-btn block color="accent" variant="flat" @click="updateMuSettings">
          <span v-if="!muSettingsSubmitting">Save</span>
          <v-progress-circular v-else :size="20" :width="2" indeterminate></v-progress-circular>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db } from '@/js/db'
import { collection, getDocs, query, updateDoc, where } from 'firebase/firestore'

export default {
  name: 'ProductionSettings',
  data() {
    return {
      settings: null,
      leadTimes: null,
      leadTimesSubmitting: false,
      muSettingsSubmitting: false,
      muSettings: {
        muCutCapacity: null,
        muWorkshopCapacity: null
        // muPackCapacity: null
      }
    }
  },
  async created() {
    const settings = await getDocs(query(collection(db, 'settings'), where('name', '==', 'public')))
    this.settingsRef = settings.docs[0].ref
    const data = settings.docs[0].data()

    // EU uses a single overall leadTime (matches the US shape)
    if (!data.leadTimes.eu) {
      data.leadTimes.eu = { leadTime: 0 }
    }

    this.settings = data

    // Set default values
    this.muSettings.muCutCapacity = this.settings.muCutCapacity
    this.muSettings.muWorkshopCapacity = this.settings.muWorkshopCapacity
    // this.muSettings.muPackCapacity = this.settings.muPackCapacity
  },
  methods: {
    async updateLeadTimes() {
      if (!this.leadTimesSubmitting) {
        this.leadTimesSubmitting = true
        await updateDoc(this.settingsRef, {
          leadTimes: this.settings.leadTimes
        })
        this.leadTimesSubmitting = false
        this.$emit('snackbar', 'Lead Times Updated')
      }
    },
    async updateMuSettings() {
      if (!this.muSettingsSubmitting) {
        this.muSettingsSubmitting = true
        await updateDoc(this.settingsRef, {
          muCutCapacity: this.muSettings.muCutCapacity,
          muWorkshopCapacity: this.muSettings.muWorkshopCapacity
          // muPackCapacity: this.muSettings.muPackCapacity
        })
        this.muSettingsSubmitting = false
        this.$emit('snackbar', 'Mu Settings Updated')
      }
    },
    sortedObject(o) {
      return Object.entries(o).sort()
    }
  }
}
</script>
